import {
  ACCESS_ROLES_ICONS,
  ACCESS_SELECT_ITEMS,
  AccessRole,
} from 'pages/ApiClients/constants/accessSelectItems';
import { required } from 'react-admin';
import { Chip } from 'shared/mui/Chips';
import { SelectInput } from 'shared/react-admin/Inputs';

export const ApiClientsAccessSelectInput: React.FC = () => (
  <SelectInput
    choices={ACCESS_SELECT_ITEMS}
    format={(value: AccessRole[]) => value?.[0] ?? ''}
    fullWidth
    label="Доступ"
    optionText={({ label, id }: (typeof ACCESS_SELECT_ITEMS)[number]) => (
      <Chip icon={ACCESS_ROLES_ICONS[id]} label={label} />
    )}
    parse={(value: AccessRole) => [value]}
    size="small"
    source="roles"
    validate={required()}
    variant="outlined"
  />
);
